export { default } from './SkeletonFareCalendarOI';
